export default "__VITE_ASSET__DKlk7hVK__"